import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { copyrightCheckerDossierDetailHref } from '../../../helpers/copyrightCheckerDossierDetailHref';
import { CopyrightCheckerDossiersOverviewTableColumns as Cols } from '../../../config/CopyrightCheckerDossiersOverviewTable';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import ArrowRight from '../../atoms/icons/ArrowRight';
import Favicon from '../../atoms/Favicon';
import * as styled from './CopyrightCheckerDossierOverviewTableRow.style';
import StatusIndicator from '../../atoms/StatusIndicator';
function CopyrightCheckerDossierOverviewTableRow({ domain, id, isDomain = false, status, detections_count, full_detections_count, embedded_detections_count, }) {
    const { t } = useTranslation();
    return (_jsxs(TableRow, { href: copyrightCheckerDossierDetailHref({ id }, isDomain), children: [_jsx(styled.TableCell, { label: t(Cols.Source.translateKey), value: lC(domain), maxWidth: Cols.Source.maxWidth, children: _jsx(Favicon, { domain: domain }) }), _jsx(TableCell, { label: t(Cols.DetectionCount.translateKey), value: lS(detections_count) }), _jsx(TableCell, { label: t(Cols.FullDetectionsCount.translateKey), value: lS(full_detections_count) }), _jsx(TableCell, { label: t(Cols.EmbeddedDetectionsCount.translateKey), value: lS(embedded_detections_count) }), _jsx(TableCell, { label: t(Cols.Status.translateKey), maxWidth: Cols.Status.maxWidth, value: status ? _jsx(StatusIndicator, { status: status }) : null }), _jsx(TableCell, { align: "right", children: _jsx(ArrowRight, { className: "icon" }) })] }));
}
export default memo(CopyrightCheckerDossierOverviewTableRow);
function lC(str = '') {
    return str.toLowerCase();
}
function lS(n = 0) {
    return n.toLocaleString('nl');
}
